var $ = require("jquery");

var PaymentMethodView = require("./_payment.payment-method");

var PaymentGatewayView = PaymentMethodView.extend({
  events: function() {
    var parentEvents = _.result(PaymentMethodView.prototype, "events");

    return _.extend(
      {
        "click [data-generate-virtual-card]": "generateVirtualCard"
      },
      parentEvents
    );
  },

  initialize: function(options) {
    PaymentMethodView.prototype.initialize.call(this, options);

    this.currency = options.currency;

    this.template = Handlebars.compile(
      this.$("[data-payment-virtual-card-template]").length
        ? this.$("[data-payment-virtual-card-template]").html()
        : ""
    );

    this.dispatcher.on(
      "paymentOption:changed",
      this.processPaymentOptionChange.bind(this)
    );
  },

  processSelection: function(event) {
    PaymentMethodView.prototype.processSelection.call(this, event);

    if (this.$("[data-payment-virtual-card-generator]").length) {
      this.$el.removeClass("is-hidden");
    }
  },

  processPaymentOptionChange: function(data) {
    this.paymentAmount = data.amount;
  },

  generateVirtualCard: function(event) {
    $.ajax({
      type: "get",
      dataType: "json",
      cache: false,
      url: $(event.currentTarget).attr("data-action"),
      data: {
        payment: {
          amount: this.paymentAmount,
          currency: this.currency
        }
      },

      beforeSend: function() {
        this.$("[data-payment-virtual-card-generator]")
          .empty()
          .addClass("is-loading");
      }.bind(this),

      success: function(response) {
        this.$("[data-payment-virtual-card-generator]")
          .html(this.template({ response: response }))
          .removeClass("is-loading");
      }.bind(this),

      error: function(response) {
        this.$("[data-payment-virtual-card-generator]")
          .html(this.template({ response: response }))
          .removeClass("is-loading");
      }
    });
  }
});

module.exports = PaymentGatewayView;
